import { Component, inject } from '@angular/core';
import {CommentService} from "../customer-overview/add-edit-customer/comment/comment.service";
import {NationalityService} from "./nationality/nationality.service";
import {FamilyStatusService} from "./family-status/family-status.service";
import {IncomeTypeService} from "./income-type/income-type.service";
import {CharacteristicService} from "./characteristic/characteristic.service";
import {StatusChangeReasonService} from "./status-change-reason/status-change-reason.service";

@Component({
    selector: 'app-administration',
    templateUrl: './administration.component.html',
    styleUrls: ['./administration.component.scss'],
    standalone: false
})
export class AdministrationComponent {
  commentService = inject(CommentService);
  nationalityService = inject(NationalityService);
  familyStatusService = inject(FamilyStatusService);
  incomeTypeService = inject(IncomeTypeService);
  characteristicService = inject(CharacteristicService);
  statusChangeReasonService = inject(StatusChangeReasonService);
}
